import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const HeaderAppBarStyle: StyleExtend<Theme> = {
  backgroundColor: (theme) => theme.palette.background.default,
  boxShadow: 'none',
};

export const HeaderToolbarStyle: StyleExtend<Theme> = {
  minHeight: (theme) => ({ xs: theme.customStyling.appBar.height }),
  borderBottom: (theme) => `1px solid ${theme.palette.customColors.lightGray}`,
  justifyContent: 'space-between',
};

export const HeaderLogoWrapperStyle: StyleExtend<Theme> = {
  maxHeight: '44px',
};

export const HeaderLogoStyle: StyleExtend<Theme> = {
  width: '100%',
  height: '100%',
};

export const HeaderLogoLinkStyle: StyleExtend<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  textTransform: 'none',
  textDecoration: 'none',
  fontWeight: 700,
  color: (theme) => theme.palette.customColors.copper,
};

export const HeaderQuoteNumberStyle: StyleExtend<Theme> = {
  inset: 0,
  flexDirection: 'row',
  justifyContent: 'center',
  gap: 1,
  width: { xs: '100%', md: 'auto' },
  margin: 'auto',
  paddingY: { xs: 1, md: 0 },
  alignItems: 'center',
  color: (theme) => theme.palette.customColors.gunMetal!,
  borderBottom: (theme) => ({
    xs: `1px solid ${theme.palette.customColors.lightGray}`,
    md: 'none',
  }),
};

export const HeaderQuoteNumberNumberStyle: StyleExtend<Theme> = {
  backgroundColor: (theme) => theme.palette.customColors.lightBeige,
  padding: '.25rem .5rem',
  borderRadius: '.25rem',
  fontFamily: 'Inter',
};
